export default __webpack_public_path__ + "static/media/arctic-wallet.ebcb0ad8.svg";